export const useFavouriteVariant = (productID: number) => ({
    pinId: productID,
    pinType: 'ProductPin' as const,
});
